export default __webpack_public_path__ + "static/media/ic-irr-linear.4f6d9ace.svg";